import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, ArrowDown, Crown } from 'lucide-react';
const promoImages = [{
  image: 'https://cdn.magicpatterns.com/uploads/3sFWFf9AzQM3tcnhAJGoxk/slide_1.png',
  alt: 'Oferta de lanzamiento: Pack completo'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/qAATN5yVSEPR47rdfYcHp1/slide_2.png',
  alt: '¿Te pasa esto con tu dinero?'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gF9vAhFXCy3Y1aVafXQgD2/slide_3.png',
  alt: '¿Cómo podrías estar en 30 días?'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/xB9U5e2jm3h9QqtuAUDjyJ/slide_4.png',
  alt: '¿Te pasa esto con tu dinero? - Pain points'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8E7HiLjujVjojU3VF9751Y/slide_5.png',
  alt: 'Pack Finanzas Fáciles para Mujeres'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/jQnRN7vVQ7EZtqQ3b8MCvc/slide_6.png',
  alt: 'Oferta especial'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/bfDdsshXMWcQ1TwMsJcPkw/slide7.png',
  alt: 'Oferta de lanzamiento con pack visual'
}];
export function PromoCampaign() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // Auto-cycle through promotional images
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex(prev => (prev + 1) % promoImages.length);
    }, 4000); // Change every 4 seconds
    return () => clearInterval(timer);
  }, []);
  return <section className="py-20 md:py-32 bg-gradient-to-b from-[#f5f1e8] to-white relative overflow-hidden" data-id="element-487">
      {/* Subtle decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#d4a574] opacity-5 rounded-full blur-3xl" data-id="element-488"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#1e3a5f] opacity-5 rounded-full blur-3xl" data-id="element-489"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-490">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-491">
          {/* Left side - Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-492">
            {/* Opening hook */}
            <div className="space-y-6" data-id="element-493">
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="text-2xl md:text-3xl font-serif text-[#1e3a5f] leading-relaxed italic" data-id="element-494">
                Empiezas leyendo una cosa… y, sin darte cuenta, ya estás tomando
                decisiones que tu{' '}
                <span className="text-[#d4a574] font-bold not-italic" data-id="element-495">
                  "yo del futuro"
                </span>{' '}
                te va a agradecer.
              </motion.p>

              <motion.p initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.4
            }} className="text-xl md:text-2xl text-gray-700 leading-relaxed" data-id="element-496">
                Es raro:{' '}
                <span className="text-[#1e3a5f] font-semibold" data-id="element-497">
                  nadie te enseñó a manejar el dinero
                </span>
                … y aun así, algo dentro de ti sabe que estás lista para
                dominarlo.
              </motion.p>
            </div>

            {/* Divider */}
            <motion.div initial={{
            opacity: 0,
            scaleX: 0
          }} whileInView={{
            opacity: 1,
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} className="h-px bg-gradient-to-r from-transparent via-[#d4a574] to-transparent" data-id="element-498" />

            {/* Product description */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.8
          }} className="space-y-6" data-id="element-499">
              <div className="flex items-start gap-3" data-id="element-500">
                <Sparkles className="w-6 h-6 text-[#d4a574] flex-shrink-0 mt-1" data-id="element-501" />
                <div data-id="element-502">
                  <div className="flex items-center gap-3 mb-3" data-id="element-503">
                    <h3 className="text-2xl font-serif font-bold text-[#1e3a5f]" data-id="element-504">
                      Finanzas Fáciles para Mujeres
                    </h3>
                    <div className="flex items-center gap-1 bg-gradient-to-r from-[#d4a574] to-[#c29463] text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-505">
                      <Crown className="w-3 h-3" data-id="element-506" />
                      <span data-id="element-507">Edición Premium</span>
                    </div>
                  </div>
                  <p className="text-lg text-gray-600 leading-relaxed mb-4" data-id="element-508">
                    Tu kit completo:
                  </p>
                  <ul className="space-y-2 text-gray-700" data-id="element-509">
                    <li className="flex items-start gap-2" data-id="element-510">
                      <span className="text-[#d4a574] font-bold" data-id="element-511">•</span>
                      <span data-id="element-512">Ebook principal</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-513">
                      <span className="text-[#d4a574] font-bold" data-id="element-514">•</span>
                      <span data-id="element-515">Diario de Dinero en Acción</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-516">
                      <span className="text-[#d4a574] font-bold" data-id="element-517">•</span>
                      <span data-id="element-518">Plan para Salir de Deudas</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-519">
                      <span className="text-[#d4a574] font-bold" data-id="element-520">•</span>
                      <span data-id="element-521">Ahorro con Propósito</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-522">
                      <span className="text-[#d4a574] font-bold" data-id="element-523">•</span>
                      <span data-id="element-524">Dinero en Pareja y Familia</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-525">
                      <span className="text-[#d4a574] font-bold" data-id="element-526">•</span>
                      <span data-id="element-527">Ingresos Extra</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-528">
                      <span className="text-[#d4a574] font-bold" data-id="element-529">•</span>
                      <span data-id="element-530">Mentalidad y Afirmaciones de Abundancia</span>
                    </li>
                  </ul>
                </div>
              </div>
            </motion.div>

            {/* Transformation promise */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 1.0
          }} className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-[#d4a574]/20 shadow-lg" data-id="element-531">
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-532">
                Todo diseñado para que,{' '}
                <span className="text-[#1e3a5f] font-semibold" data-id="element-533">
                  paso a paso
                </span>
                , transformes el{' '}
                <span className="line-through text-gray-400" data-id="element-534">
                  caos financiero
                </span>{' '}
                en{' '}
                <span className="text-[#d4a574] font-bold" data-id="element-535">
                  claridad, control y tranquilidad real
                </span>{' '}
                con el dinero.
              </p>
            </motion.div>

            {/* Premium CTA Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 1.2
          }} className="relative" data-id="element-536">
              {/* Premium Badge */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-537">
                <div className="bg-gradient-to-r from-[#d4a574] to-[#c29463] text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider shadow-lg flex items-center gap-1.5" data-id="element-538">
                  <Crown className="w-4 h-4" data-id="element-539" />
                  <span data-id="element-540">Edición Premium</span>
                </div>
              </div>

              <a href="#oferta" className="group block" data-id="element-541">
                <div className="bg-gradient-to-br from-[#1e3a5f] via-[#152d47] to-[#1e3a5f] rounded-2xl p-8 shadow-2xl border-2 border-[#d4a574] hover:border-[#c29463] transition-all hover:shadow-[0_20px_60px_-15px_rgba(212,165,116,0.5)] hover:-translate-y-1" data-id="element-542">
                  <div className="text-center space-y-4" data-id="element-543">
                    <div className="flex justify-center" data-id="element-544">
                      <motion.div animate={{
                      y: [0, 8, 0]
                    }} transition={{
                      duration: 2,
                      repeat: Infinity,
                      ease: 'easeInOut'
                    }} data-id="element-545">
                        <ArrowDown className="w-8 h-8 text-[#d4a574]" data-id="element-546" />
                      </motion.div>
                    </div>

                    <h4 className="text-white text-2xl md:text-3xl font-serif font-bold" data-id="element-547">
                      Obtener Edición Premium Ahora
                    </h4>

                    <p className="text-gray-300 text-base md:text-lg max-w-md mx-auto" data-id="element-548">
                      Acceso inmediato al pack completo + bonos exclusivos de la
                      edición premium
                    </p>

                    <div className="pt-2" data-id="element-549">
                      <span className="inline-flex items-center gap-2 text-[#d4a574] font-semibold text-sm group-hover:gap-3 transition-all" data-id="element-550">
                        Ver oferta especial de lanzamiento
                        <ArrowDown className="w-4 h-4 group-hover:translate-y-1 transition-transform" data-id="element-551" />
                      </span>
                    </div>
                  </div>
                </div>
              </a>
            </motion.div>
          </motion.div>

          {/* Right side - Auto-cycling promotional images */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative" data-id="element-552">
            <div className="relative aspect-square max-w-lg mx-auto" data-id="element-553">
              <AnimatePresence mode="wait" data-id="element-554">
                <motion.div key={currentImageIndex} initial={{
                opacity: 0,
                scale: 0.95
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.95
              }} transition={{
                duration: 0.6
              }} className="absolute inset-0" data-id="element-555">
                  <img src={promoImages[currentImageIndex].image} alt={promoImages[currentImageIndex].alt} className="w-full h-full object-contain rounded-2xl shadow-2xl" data-id="element-556" />
                </motion.div>
              </AnimatePresence>

              {/* Progress indicators */}
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-557">
                {promoImages.map((_, index) => <button key={index} onClick={() => setCurrentImageIndex(index)} className={`transition-all duration-300 rounded-full ${index === currentImageIndex ? 'bg-[#d4a574] w-8 h-2' : 'bg-gray-300 hover:bg-gray-400 w-2 h-2'}`} aria-label={`Ver imagen ${index + 1}`} data-id="element-558" />)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}